import styled from "@emotion/styled";

export const EXPANDEDWIDTH = 300;
export const COLLAPSEDWIDTH = 80; // 32 internal width + 24 padding on each side
export const ADMIN_BAR_HEIGHT = 32;

export const StaticWrapper = styled.div<{ stayExpanded: boolean }>(({ stayExpanded, theme }) => ({
  zIndex: 6,
  width: stayExpanded ? EXPANDEDWIDTH : COLLAPSEDWIDTH,
  minHeight: "100vh",
  position: "relative",
  backgroundColor: theme.colors.sysBackgroundDefault,

  "@media print": {
    display: "none",
  },
}));

export const ExpandableWrapper = styled.div<{ expanded: boolean; showShadow: boolean }>(
  ({ theme, expanded, showShadow }) => ({
    height: "100%",
    flexShrink: 0,
    backgroundColor: theme.colors.sysBackgroundDefault,
    boxShadow: showShadow ? "rgba(0, 0, 0, 0.1) 0px 4px 10px" : "none",
    borderRight: `1px solid ${theme.colors.sysBorderDecorative}`,
    display: "flex",
    flexDirection: "column",
    padding: 24,
    width: expanded ? EXPANDEDWIDTH : COLLAPSEDWIDTH,
    transition: "width 0.5s, transform 0.3s, box-shadow 0.3s",
    overflow: "hidden",
    overflowY: expanded ? "auto" : "hidden",
    scrollbarWidth: "none",
  }),
);

export const TopRow = styled.div({
  display: "flex",
  marginBottom: 24,
  gap: 16,
});

export const FadeInWrapper = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",

  animation: "fadeIn 0.3s forwards",
});

export const LogoWrapper = styled.a(({ theme }) => ({
  height: 32,
  width: 32,
  userSelect: "none",

  "&:focus-visible": {
    outline: `2px solid ${theme.colors.sysPrimarySubtleAlt}`,
  },
}));

export const Logo = styled.img({
  height: 32,
  width: 32,
});

export const MainNav = styled.nav({
  paddingTop: 16,
  paddingBottom: 16,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: 12,
});

export const FooterNav = styled.nav<{ isAdminBarVisible?: boolean }>(
  ({ theme, isAdminBarVisible = false }) => ({
    width: "100%",
    borderTop: `1px solid ${theme.colors.sysBorderDecorative}`,
    paddingTop: 16,
    paddingBottom: isAdminBarVisible ? ADMIN_BAR_HEIGHT : 16, // Add extra padding when admin bar is visible
    display: "flex",
    flexDirection: "column",
    gap: 12,
  }),
);

export const Divider = styled.div(({ theme }) => ({
  height: 1,
  backgroundColor: theme.colors.sysBorderDecorative,
  margin: "8px 0",
}));

export const ExpandButton = styled.button(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: 32,
  width: 32,
  borderRadius: 4,
  cursor: "pointer",
  color: theme.colors.sysTextPlaceholder,
  backgroundColor: "transparent",
  border: "none",
  transition: "all 0.3s",

  "&:hover": {
    color: theme.colors.sysTextDefault,
  },
  "&:focus-visible": {
    outline: `2px solid ${theme.colors.sysPrimarySubtleAlt}`,
  },
}));
